(function() {
  var __snippets__ = {};
  (function() {
    var element = document.getElementById("snippets-script");
    var attribute = element ? element.getAttribute("data-snippets") : '';
    var snippets = attribute.split(",").filter(Boolean);

    for (var i = 0; i < snippets.length; i++) {
      __snippets__[snippets[i]] = true;
    }
  })();
  (function() {
  if (!__snippets__["bbcino-bestsellers"] && !Shopify.designMode) return;
  try {
    function initBbpSellers(){document.querySelectorAll('[data-bbp-sellers]').forEach(root=>{if(root.dataset.ready)return;root.dataset.ready='true';const track=root.querySelector('.bbp-sellers-track');const pause=root.querySelector('[data-bbp-pause]');const motion=window.matchMedia('(prefers-reduced-motion: reduce)');let paused=motion.matches;let visible=false;let interacting=false;function advance(step){const end=track.scrollWidth-track.clientWidth;let left=track.scrollLeft+step*track.clientWidth;if(step>0&&track.scrollLeft>=end-5)left=0;if(step<0&&track.scrollLeft<5)left=end;track.scrollTo({left,behavior:motion.matches?'instant':'smooth'});}function update(){pause.textContent=paused?'▶':'Ⅱ';pause.setAttribute('aria-label',paused?root.dataset.resumeLabel:root.dataset.pauseLabel);}root.querySelectorAll('[data-bbp-step]').forEach(button=>button.addEventListener('click',()=>advance(Number(button.dataset.bbpStep))));pause.addEventListener('click',()=>{paused=!paused;update();});track.addEventListener('mouseenter',()=>interacting=true);track.addEventListener('mouseleave',()=>interacting=false);track.addEventListener('focusin',()=>interacting=true);track.addEventListener('focusout',()=>interacting=false);track.addEventListener('keydown',event=>{if(event.key==='ArrowRight'||event.key==='ArrowLeft'){event.preventDefault();advance(event.key==='ArrowRight'?1:-1);}});motion.addEventListener('change',()=>{if(motion.matches){paused=true;update();}});const observer=new IntersectionObserver(entries=>visible=entries[0].isIntersecting,{threshold:.6});observer.observe(track);const timer=setInterval(()=>{if(!root.isConnected){clearInterval(timer);observer.disconnect();return;}if(!paused&&visible&&!interacting&&!document.hidden)advance(1);},5000);update();});}
initBbpSellers();document.addEventListener('shopify:section:load',initBbpSellers);
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__snippets__["header-option-item__account"] && !Shopify.designMode) return;
  try {
    document.addEventListener('click', event => {
  document.querySelectorAll('.bb-account-menu[open]').forEach(menu => {
    if (!menu.contains(event.target)) menu.removeAttribute('open');
  });
});
document.addEventListener('keydown', event => {
  if (event.key !== 'Escape') return;
  document.querySelectorAll('.bb-account-menu[open]').forEach(menu => {
    menu.removeAttribute('open');
    menu.querySelector('summary').focus();
  });
});
  } catch(e) { console.error(e); }
})();

})();
